// EditProductProvider.tsx
import React, { Component } from 'react';
import EditProductContext from './EditProductContext';
import store from '../../../store/store';
import { TransactionTableStyledMemory } from '../../BaseComponent/memory';
import { editProduct } from '../services';

/**
 * @param startPage always should be 0 when it comes to 1st page since react-pagination require 1st page to be index = 0
 */

class EditProductProvider extends TransactionTableStyledMemory {
  primaryMemory = {};

  state = {
    jwtToken: '',
    userToken: '',
    userData: '',
    primaryMemory: this.primaryMemory,
  };

  prevState = [];

  setJwtToken = (jwtToken) => {
    if (jwtToken !== this.state.jwtToken) {
      this.setState({
        ...this.state,
        jwtToken,
      });
    }
  };

  setUserToken = (userToken) => {
    if (userToken !== this.state.userToken) {
      this.setState({
        ...this.state,
        userToken,
      });
    }
  };

  editProfile = ({ ...options }) => {
    const convState = {
      ...this.state,
      jwtToken: options.token,
    };

    this.makeDispatch(options);
  };

  makeDispatch = async ({ ...options }) => {
    return store.dispatch(editProduct(options));
  };

  render() {
    const contextValue = {
      jwtToken: this.state.jwtToken,
      setJwtToken: this.setJwtToken,
      editProfile: this.editProfile,
      setUserToken: this.setUserToken,
      userToken: this.state.userToken,
      primaryMemory: this.state.primaryMemory,
    };

    return <EditProductContext.Provider value={contextValue}>{this.props.children}</EditProductContext.Provider>;
  }
}

export default EditProductProvider;
